import { IAction } from "../../../interface/action.interface";
import { SortableListBuilderColumns } from "../enum/list-builder-table-columns";
import { IListBuilderTableResponseDto } from "../interface/dto/list-builder-table-list.dto";

export enum ListBuilderTableActionType {
    LIST_BUILDER_TABLE_INIT = "LIST_BUILDER_TABLE_INIT",
    LIST_BUILDER_TABLE_LOAD = "LIST_BUILDER_TABLE_LOAD",
    LIST_BUILDER_TABLE_SUCCESS = "LIST_BUILDER_TABLE_SUCCESS",
    LIST_BUILDER_TABLE_ERROR = "LIST_BUILDER_TABLE_ERROR",
    LIST_BUILDER_TABLE_SET_SORTING = "LIST_BUILDER_TABLE_SET_SORTING",
    LIST_BUILDER_TABLE_SET_PAGINATION = "LIST_BUILDER_TABLE_SET_PAGINATION",
    LIST_BUILDER_TABLE_SET_SEARCH_QUERY = "LIST_BUILDER_TABLE_SET_SEARCH_QUERY",
    LIST_BUILDER_TABLE_DUPLICATE = "LIST_BUILDER_TABLE_DUPLICATE",
    LIST_BUILDER_TABLE_DELETE = "LIST_BUILDER_TABLE_DELETE",
    LIST_BUILDER_TABLE_SET_CURRENT_USER = "LIST_BUILDER_TABLE_SET_CURRENT_USER",
    LIST_BUILDER_TABLE_BUILD = "LIST_BUILDER_TABLE_BUILD",
    LIST_BUILDER_TABLE_DOWNLOAD = "LIST_BUILDER_TABLE_DOWNLOAD",
    LIST_BUILDER_TABLE_START_AUTO_REFRESH = "LIST_BUILDER_TABLE_START_AUTO_REFRESH",
    LIST_BUILDER_TABLE_STOP_AUTO_REFRESH = "LIST_BUILDER_TABLE_STOP_AUTO_REFRESH",
    LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION = "LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION",
    LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION_SUCCESS = "LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION_SUCCESS",
}

interface IListBuilderTableInitAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_INIT;
}

interface IListBuilderTableLoadAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_LOAD;
}

interface IListBuilderTableSuccessAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SUCCESS;
    payload: IListBuilderTableResponseDto;
}

interface IListBuilderTableErrorAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_ERROR;
    payload: string;
}

interface IListBuilderTableSetSortingAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SORTING;
    payload: { column: SortableListBuilderColumns; order: "asc" | "desc" };
}

interface IListBuilderTableSetPaginationAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_PAGINATION;
    payload: { currentPage: number; itemsPerPage: number };
}

interface IListBuilderTableSetSearchQueryAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SEARCH_QUERY;
    payload: string;
}

interface IListBuilderTableDuplicateAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DUPLICATE;
    payload: {
        id: number;
    };
}

interface IListBuilderTableDeleteAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DELETE;
    payload: {
        id: number;
    };
}

interface IListBuilderTableSetCurrentUserAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_CURRENT_USER;
    payload: {
        email: string;
    };
}

interface IListBuilderTableBuildAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_BUILD;
    payload: {
        id: number;
    };
}

interface IListBuilderTableDownloadAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DOWNLOAD;
    payload: {
        id: number;
    };
}

interface IListBuilderTableStartAutoRefreshAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_START_AUTO_REFRESH;
}

interface IListBuilderTableStopAutoRefreshAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_STOP_AUTO_REFRESH;
}

interface IListBuilderTableCheckCreatePermissionAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION;
}

interface IListBuilderTableCheckCreatePermissionSuccessAction extends IAction {
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION_SUCCESS;
    payload: boolean;
}

export const listBuilderTableInitAction = () => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_INIT,
});

export const listBuilderTableLoadAction = (): IListBuilderTableLoadAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_LOAD,
    payload: {},
});

export const listBuilderTableSuccessAction = (
    payload: IListBuilderTableResponseDto,
): IListBuilderTableSuccessAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SUCCESS,
    payload,
});

export const listBuilderTableErrorAction = (
    payload: string,
): IListBuilderTableErrorAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_ERROR,
    payload,
});

export const listBuilderTableSetSortingAction = (
    column: SortableListBuilderColumns,
    order: "asc" | "desc",
): IListBuilderTableSetSortingAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SORTING,
    payload: { column, order },
});

export const listBuilderTableSetPaginationAction = (
    currentPage: number,
    itemsPerPage: number,
): IListBuilderTableSetPaginationAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_PAGINATION,
    payload: { currentPage, itemsPerPage },
});

export const listBuilderTableSetSearchQueryAction = (
    payload: string,
): IListBuilderTableSetSearchQueryAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SEARCH_QUERY,
    payload,
});

export const listBuilderTableDuplicateAction = (
    id: number,
): IListBuilderTableDuplicateAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DUPLICATE,
    payload: {
        id,
    },
});

export const listBuilderTableDeleteAction = (
    id: number,
): IListBuilderTableDeleteAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DELETE,
    payload: {
        id,
    },
});

export const listBuilderTableSetCurrentUserAction = (
    email: string,
): IListBuilderTableSetCurrentUserAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_CURRENT_USER,
    payload: { email },
});

export const listBuilderTableBuildAction = (
    id: number,
): IListBuilderTableBuildAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_BUILD,
    payload: {
        id,
    },
});

export const listBuilderTableDownloadAction = (
    id: number,
): IListBuilderTableDownloadAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_DOWNLOAD,
    payload: {
        id,
    },
});
export const listBuilderTableStartAutoRefreshAction =
    (): IListBuilderTableStartAutoRefreshAction => ({
        type: ListBuilderTableActionType.LIST_BUILDER_TABLE_START_AUTO_REFRESH,
        payload: {},
    });

export const listBuilderTableStopAutoRefreshAction =
    (): IListBuilderTableStopAutoRefreshAction => ({
        type: ListBuilderTableActionType.LIST_BUILDER_TABLE_STOP_AUTO_REFRESH,
        payload: {},
    });

export const listBuilderTableCheckCreatePermissionAction =
    (): IListBuilderTableCheckCreatePermissionAction => ({
        type: ListBuilderTableActionType.LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION,
        payload: {},
    });

export const listBuilderTableCheckCreatePermissionSuccessAction = (
    canCreate: boolean,
): IListBuilderTableCheckCreatePermissionSuccessAction => ({
    type: ListBuilderTableActionType.LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION_SUCCESS,
    payload: canCreate,
});

export type IListBuilderTableActions =
    | IListBuilderTableInitAction
    | IListBuilderTableLoadAction
    | IListBuilderTableSuccessAction
    | IListBuilderTableErrorAction
    | IListBuilderTableSetSortingAction
    | IListBuilderTableSetPaginationAction
    | IListBuilderTableSetSearchQueryAction
    | IListBuilderTableDuplicateAction
    | IListBuilderTableDeleteAction
    | IListBuilderTableSetCurrentUserAction
    | IListBuilderTableBuildAction
    | IListBuilderTableDownloadAction
    | IListBuilderTableStartAutoRefreshAction
    | IListBuilderTableStopAutoRefreshAction
    | IListBuilderTableCheckCreatePermissionAction
    | IListBuilderTableCheckCreatePermissionSuccessAction;
